import CancelableApi from "./CancelableApi";
import CancelableAxiosInstance from "./CancelableAxiosInstance";
import { BaseEvalPass, EvalObs, EvalWorkflow, Marker } from "./EvalWorkflowApi";

export enum EvalStudyStep {
  initial = "initial",
  reconciling = "reconciling",
  reading = "reading",
  done = "done",
  excluded = "excluded",
}

export interface EvalPassResult {
  author: string;
  workflow: EvalWorkflow;
  falsePositive: number;
  falseNegative: number;
  truePositive: number;
  trueNegative: number;
  nbMarkerOutsideAnyGTRegion: number;
  totalObs: number;
  foundObsCodes: Array<string>;
}

export interface AdminEvalStudy {
  id: string;
  passes: Array<AdminEvalPass>;
  results: Array<EvalPassResult>;
  studyId: string;
  evalCode: string;
  step: EvalStudyStep;
}

export interface AdminEvalPass extends BaseEvalPass {
  author: string;
  at: string;
  secDuration: number;
  secDurationBeforeAiActivation: number;
  _result: EvalPassResult;
}

export default class EvalStudyAdminApi extends CancelableApi {
  static with(axios: CancelableAxiosInstance) {
    return new EvalStudyAdminApi(axios);
  }

  findByStudyId(studyId: string): Promise<AdminEvalStudy[]> {
    return this.client.get("/eval-studies", { params: { studyId } }).then((resp) => resp.data);
  }
}
